import * as A from '@core/arena'

import { CategoryItems } from '@openforis/arena-core'

import { uuidv4 } from '@core/uuid'
import * as ObjectUtils from '@core/objectUtils'
import * as StringUtils from '@core/stringUtils'

export const keys = {
  uuid: ObjectUtils.keys.uuid,
  props: ObjectUtils.keys.props,
  parentUuid: 'parentUuid',
  levelUuid: 'levelUuid',
  published: ObjectUtils.keys.published,
}

export const keysProps = {
  code: 'code',
  extra: 'extra',
  labels: ObjectUtils.keysProps.labels,
  descriptions: ObjectUtils.keysProps.descriptions,
  index: 'index',
}

const codeAllowedCharacters = [
  '-', // minus symbol first to avoid considering it as a range in the RegExp
  '*',
  '+',
  '\\\\', // single backslash "\" character (it requires a double escape to be used in the RegExp)
  String.raw`\/`,
  '|',
  String.raw`\w`,
]
const codeNotAllowedCharactersRegExp = new RegExp(`[^${codeAllowedCharacters.join('')}]`, 'g')

// ====== CREATE
export const newItem = (levelUuid, parentItemUuid = null, props = {}) => ({
  [keys.uuid]: uuidv4(),
  [keys.levelUuid]: levelUuid,
  [keys.parentUuid]: parentItemUuid,
  [keys.props]: props,
})

// ====== READ
export const {
  getDescription,
  getDescriptions,
  getExtra,
  getExtraProp,
  getId,
  getLabels,
  getProps,
  getPropsDraft,
  getPropsAndPropsDraft,
  getUuid,
  isEqual,
  isPublished,
  isDraft,
} = ObjectUtils
export const getLevelUuid = A.prop(keys.levelUuid)
export const getParentUuid = A.prop(keys.parentUuid)
export const getCode = ObjectUtils.getProp(keysProps.code, '')
export const getLabel =
  (language, defaultToCode = true) =>
  (item) =>
    ObjectUtils.getLabel(language, defaultToCode ? getCode(item) : '')(item)
export const getLabelWithCode = (language) => (item) => CategoryItems.getLabelWithCode(item, language)
export const getIndex = CategoryItems.getIndex

// ====== UPDATE
export const assocProp = ({ key, value }) => ObjectUtils.setProp(key, value)
// ====== UPDATE - Extra Props
export const dissocExtraProp = (key) => A.dissocPath([keys.props, keysProps.extra, key])
export const renameExtraProp =
  ({ nameOld, nameNew }) =>
  (item) => {
    const extra = getExtra(item)
    const extraUpdated = { ...extra }
    const extraProp = extra[nameOld]
    delete extraUpdated[nameOld]
    extraUpdated[nameNew] = extraProp
    return assocProp({ key: keysProps.extra, value: extraUpdated })(item)
  }

// ====== UTILS

// gets the ancestor codes as an array (only if ancestor codes have been populated during fetch)
export const getAncestorCodes = (item) => {
  const getLevelCode = (levelIndex) => A.propOr(null, `level${levelIndex}Code`)

  const codes = []
  let levelIndex = 0
  let levelCode = getLevelCode(levelIndex)(item)
  while (levelCode !== null) {
    codes.push(levelCode)
    levelIndex += 1
    levelCode = getLevelCode(levelIndex)(item)
  }
  return codes
}

export const getCodesHierarchy = (item) => [...getAncestorCodes(item), getCode(item)]

export const normalizeCode = A.pipe(
  StringUtils.leftTrim,
  A.replace(codeNotAllowedCharactersRegExp, '_'),
  A.slice(0, 40)
)
